export const __CONFIG_NAME__ = '__app_config__'
export const __HTML_ROOT__ = 'root'
export const __STYLE_ROOT__ = 'jss-server-side'
export const __INT_API_NAME__ = '__int_api_state__'
